"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalTanklessROFilter = exports.State = void 0;
const effect_1 = require("effect");
const volume_1 = require("../../../../../unit/volume");
const _util_1 = require("./_util");
const Definition = __importStar(require("./common"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.GlobalTanklessROFilter';
const TAG = 'GlobalTanklessROFilter';
const LABEL = 'Global Tankless RO Filter';
exports.State = Definition.BaseState.pipe(effect_1.Schema.extend(Definition.ExpendableState), effect_1.Schema.extend(Definition.ExpirableState)).annotations({
    identifier: `${NAMESPACE}.State`,
    title: `${LABEL} State`,
});
class GlobalTanklessROFilter extends Definition.ExpendableInUsGallons.extend(`${NAMESPACE}.${TAG}`)({ _tag: effect_1.Schema.tag(TAG), ...Definition.Fields }, {
    identifier: `${NAMESPACE}.${TAG}`,
    title: LABEL,
    description: 'Filter cartridge used within Global Tankless RO devices',
}) {
    static id = 'tlro_filter';
    static label = LABEL;
    static category = Definition.Category.Filter;
    static expirable = true;
    static hasBatch = false;
    static State = exports.State;
    // TODO(Q40/Q41): placeholder item until the vendor confirms the compatible filter models and their capacity
    static catalogue = {
        tlro_filter_standard: this.make({
            id: 'tlro_filter_standard',
            name: 'Global Tankless RO Filter',
            rangeTrigger: volume_1.UsGallon.make({ amount: 750 - 75 }),
            rangeExhaust: volume_1.UsGallon.make({ amount: 750 }),
        }),
    };
    static legacyCatalogueItemIdMap = {};
    static CatalogueItemFromId = (0, _util_1.makeCatalogueItemFromId)(this).annotations({
        identifier: `${NAMESPACE}.CatalogueItemFromId`,
    });
}
exports.GlobalTanklessROFilter = GlobalTanklessROFilter;
Definition.satisfiesConstructor(GlobalTanklessROFilter);
//# sourceMappingURL=global-tankless-ro-filter.js.map